import React from 'react';
import {
  Filter as FilterAdmin,
  AutocompleteInput,
  ReferenceInput,
} from 'react-admin';

import {
  PeriodoInput,
  IntegerInput,
  PrecoInput,
} from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils/constants';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <IntegerInput source="id" label="ID" prefixo="#" />
    <PeriodoInput
      source="periodo"
      label="Período"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <ReferenceInput
      fullWidth
      label="Cliente"
      source="cliente_id"
      reference="clientes"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <PrecoInput
      source="valor"
      label="Valor da Devolução"
      fixedDecimalScale={false}
    />
  </FilterAdmin>
);

export default Filter;
